export default function Differentiation() {
  return (
    <section className="grid grid-cols-1 md:grid-cols-2">
      <div className="bg-charcoal text-white p-16 lg:p-20 flex flex-col justify-center">
        <p className="text-xs uppercase tracking-wider text-gray-400 mb-6 font-semibold">
          WHY WE'RE DIFFERENT
        </p>
        
        <h2 className="text-4xl font-semibold leading-tight mb-10">
          We're Not a Lender.<br />We're Funding Strategists.
        </h2>

        <div className="space-y-6">
          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-checkbox-circle-fill text-xl text-accent"></i>
            </div>
            <p className="text-lg font-medium">
              Underwriter-Style Approach to Fundability
            </p>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-checkbox-circle-fill text-xl text-accent"></i>
            </div>
            <p className="text-lg font-medium">
              We Fix What Lenders See Before You Apply
            </p>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-checkbox-circle-fill text-xl text-accent"></i>
            </div>
            <p className="text-lg font-medium">
              Long-Term Strategy, Not Quick Fixes
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white text-navy p-16 lg:p-20 flex flex-col justify-center">
        <div className="space-y-6 mb-8">
          <p className="text-base leading-relaxed">
            Most funding companies are either lenders trying to sell you their products, or brokers who submit your application everywhere hoping something sticks.
          </p>

          <p className="text-base leading-relaxed">
            We're different. We don't sell loans. We build fundable profiles and package you to qualify for real approvals from the institutions that matter.
          </p>

          <p className="text-base leading-relaxed">
            Our team thinks like underwriters because we understand what lenders actually look for. We prepare your business structure, credit profile, and documentation before you ever apply — so when you do, you're positioned to win.
          </p>
        </div>

        <div className="bg-gray-50 border-l-4 border-navy p-6 rounded-lg">
          <p className="text-sm italic text-gray-700">
            "We don't guess. We don't hope. We prepare you to qualify — then we execute with precision."
          </p>
        </div>
      </div>
    </section>
  );
}
